import * as actionTypes from './actionsTypes';

export function getVisitsList(params) {
	/**
	 * @param clientId
	 * @param siteId
	 * @param clientReference
	 */
	return {
		type: actionTypes.VISITS_LIST_GET,
		payload: {
			params,
		},
	};
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/visits.js